import { Toggle } from '@carbon/react'
import type { FormToggleProps } from './types'
import { FormFieldLabel } from './FormFieldLabel'
import styles from './FormField.module.scss'

const DEFAULT_LABEL_A = 'Non'
const DEFAULT_LABEL_B = 'Oui'

/**
 * Interrupteur Carbon avec libellés latéraux (défaut Non / Oui), aligné sur les autres FormField.
 */
export function FormToggle({
  label,
  required,
  error,
  hint,
  className = '',
  toggled,
  defaultToggled,
  onToggle,
  name,
  id,
  disabled = false,
  readOnly,
  size = 'md',
  labelA = DEFAULT_LABEL_A,
  labelB = DEFAULT_LABEL_B,
}: FormToggleProps) {
  const fieldId =
    id || name || `toggle-${Math.random().toString(36).slice(2, 9)}`

  const legendId = `${fieldId}-legend`

  return (
    <div className={`${styles.wrapper} ${className}`}>
      <div className={`${styles.fieldWrapper} ${styles.toggleField}`}>
        <span id={legendId} className={styles.toggleLegend}>
          <FormFieldLabel label={label} required={required} />
        </span>
        <Toggle
          id={fieldId}
          aria-labelledby={legendId}
          size={size}
          labelA={labelA}
          labelB={labelB}
          toggled={toggled}
          defaultToggled={defaultToggled}
          onToggle={onToggle}
          disabled={disabled}
          readOnly={readOnly}
        />
      </div>
      {error ? (
        <p className={styles.errorText} role="alert">
          {error}
        </p>
      ) : hint ? (
        <p className={styles.hint}>{hint}</p>
      ) : null}
    </div>
  )
}
